const packages = () => {
  const tabs = document.querySelectorAll('.js-packages-tabs');
  const items = document.querySelectorAll('.js-packages-item');
  const formWrapper = document.querySelector('.js-packages-form-wrapper');
  const buttons = document.querySelectorAll('.js-package-button');
  const select = document.querySelector('.js-package-select');

  if (
    tabs.length === 0 ||
    items.length === 0 ||
    !formWrapper ||
    buttons.length === 0 ||
    !select
  )
    return;

  const scrollToWrapper = () => {
    setTimeout(() => {
      window.scrollTo({
        top:
          formWrapper.parentElement.getBoundingClientRect().top +
          window.scrollY +
          240,
        left: 0,
        behavior: 'smooth',
      });
    }, 200);
  };

  const replaceItems = tabIndex => {
    items.forEach(item => {
      const { index } = item.dataset;

      if (index === tabIndex) {
        item.classList.add('is-active');
      } else {
        item.classList.remove('is-active');
      }
    });

    tabs.forEach(tab => {
      const { index } = tab.dataset;

      if (index === tabIndex) {
        tab.classList.remove('c-button--primary-outline');
        tab.classList.add('c-button--primary');
      } else {
        tab.classList.remove('c-button--primary');
        tab.classList.add('c-button--primary-outline');
      }
    });

    formWrapper.classList.remove('is-active');
  };

  const setSelectOptions = packageIndex => {
    const children = [];
    let selectOption = null;
    items.forEach(packageItem => {
      if (packageItem.classList.contains('is-active')) {
        const element = document.createElement('option');
        const title = packageItem.querySelector('.c-package__title');
        element.textContent = title.textContent;
        element.value = title.textContent;
        children.push(element);

        const { item } = packageItem.dataset;
        if (packageIndex === item) {
          selectOption = element.value;
        }
      }
    });

    select.replaceChildren(...children);
    select.value = selectOption;
  };

  tabs.forEach(tab => {
    tab.addEventListener('click', () => replaceItems(tab.dataset.index));
  });

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const { item } = button.closest('.js-packages-item').dataset;
      formWrapper.classList.add('is-active');
      setSelectOptions(item);
      scrollToWrapper();
    });
  });
};

export default packages;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/packages.js